import { recipe } from "@vanilla-extract/recipes";

import { zIndexes } from "../../theme/zIndex";
import { theme } from "../../theme/css/theme.css";

export const backdropStyle = recipe({
  base: {
    position: "fixed",
    border: 0,
    top: 0,
    left: 0,
    width: "100dvw",
    height: "100dvh",
    overflow: "auto",
    pointerEvents: "auto",
    zIndex: zIndexes.portal,
    ":before": {
      content: "",
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: theme.colors.onBackground,
      opacity: 0.5,
    },
  },
  variants: {
    variant: {
      default: {},
      opaque: {
        ":before": {
          opacity: 0,
        },
      },
      clickThrough: {
        pointerEvents: "none",
        ":before": {
          display: "none",
        },
      },
    },
  },
  defaultVariants: {
    variant: "default",
  },
});
